/**
 * Copied from
 * https://github.com/jumpn/utils-graphql/blob/master/src/hasSubscription.js
 * The `@jumpn/utils-graphql package is unmaintained and incompatible with newer
 * versions of `graphql` NPM package.
 *  */

import type { DocumentNode } from 'graphql';

const isSubscription = (definition) =>
  definition.kind === 'OperationDefinition' &&
  definition.operation === 'subscription';

/**
 * Returns true if documentNode has a subscription or false otherwise
 */
export const hasSubscription = (documentNode: DocumentNode): boolean =>
  documentNode.definitions.some(isSubscription);
